// extracted by mini-css-extract-plugin
module.exports = {"root":"Injector_root__3kvxC","shaded":"Injector_shaded__240p0"};